<template>
  <div>
    <div class=" mainLoader" v-if="loading">
      <!-- <img src="../assets/images/load.gif" width="100px"> -->
    </div>
    <div class="realbody">
      <div class="top_summary">
        <div class="container">
          <div class="row">
            <div class="col-md-5 leftad">
              <p class="top_summary_header mplus2p-m spacing4 noiseblack">{{$t('c_title')}}</p>
              <p class="top_summary_comment mplus2p-r spacing1-2 noiseblack">{{$t('c_desc')}}</p>
            </div>
            <div class="col-md-7 rightad">
              <img src="../../assets/imgs/illust-company-section-about.png" class="companyad" />
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row" style="margin-top: 40px;">
          <div class="col-md-3">

            <app-sidenav :selectedItem="selectedItem"></app-sidenav>

          </div>
          <div class="col-md-9">
            <div class="page_title">
              <span class="page_title_comment mplus2p-m spacing1-2 noiseblack">{{$t('replay')}} List</span>
            </div>

            <!-- <div class="row companyview-topoptions">
            <div class="col-md-3">
                <div class="selectdiv">
                <select>
                    <option class="checklabel mplus2p-m spacing1-2 noiseblack" value="aaa">{{$t('c_search_select')}}</option>
                    <option class="checklabel mplus2p-m spacing1-2 noiseblack" value="bbb">aaa</option>
                    <option class="checklabel mplus2p-m spacing1-2 noiseblack" value="ccc">aaa</option>
                </select>
                </div>
            </div>
            <div class="col-md-9">
                <div class="rtoptions">
                <input class="styled-checkbox" id="option01" type="checkbox" value="value01">
                <label class="checklabel mplus2p-m spacing1-2 noiseblack" for="option01">{{$t('c_shorting_check1')}}</label>
                </div>
                <div class="rtoptions">
                <input class="styled-checkbox" id="option02" type="checkbox" value="value02">
                <label class="checklabel mplus2p-m spacing1-2 noiseblack" for="option02">{{$t('c_shorting_check2')}}</label>
                </div>
            </div>
            </div> -->
            <div v-if="groups == ''" class="row companyviews">
              <div class="col-md-12 ceboxes">
                <div class="alert alert-danger text-center">
                  <strong>{{$t('err_replied')}}</strong>
                </div>
              </div>
            </div>
            <div v-else class="row companyviews" v-for="(group,index) of groups" :key="index">
              <div class="col-md-12 ceboxes">
                <div class="col-md-12 text-right">
                  <span v-if="group.message_time == null" class="chatdate mplus2p-r black spacing1-2"></span>
                  <span v-else class="chatdate mplus2p-r black spacing1-2">{{group.message_time}}</span>
                  <i class="fa fa-circle blue chatmanstatus" aria-hidden="true"></i>
                </div>
                <div id="pointer">
                  <span class="newtag cocogothic spacing1-2">NEW</span>
                </div>
                <div class="row">
                  <div class="col-md-3" style="text-align: center;">
                    <img class="c_images" style="width: 150px;height: 150px;" :src="group.receiver_profile" />

                  </div>
                  <div class="col-md-9" style="text-align: left;">
                    <router-link :to="{ name: 'companyDetail', params: {cid: group.company_id} }" target="_blank">
                      <p class="ctitle mplus2p-m spacing1-2 noiseblack">{{group.receiver_name}}</p>
                    </router-link>
                    <p class="ccontents mplus2p-m spacing1-2 noiseblack" v-html="group.last_message">
                    </p>

                    <button class="btn whitebtn clickcbtn" @click="sandMsg(group.company_id)" style="margin-right: 10px;">
                      <i class="fa fa-envelope margin-r-5"></i>
                    </button>
                  </div>
                </div>
              </div>

            </div>
            <!-- <div v-if="groups != ''" class="pagination justify-content-end mt-2">
              <vue-pagination :total="totalPage"  v-model="page" @input="nextPage"></vue-pagination>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Hashids from "hashids";
import axios from "axios";
import e_sidenav from "./e_engineer_sidenav";

export default {
  data() {
    return {
      selectedItem: 3,

      title: "",

      loading: false,
      window_width: "",
      page: 1,
      groups: [],
      role: "",
      userId: "",

      loading: false,
      image: null,
      totalPage: 1,
      record: "",
      show: false
    };
  },
  created() {
    if (localStorage.getItem("role") == "engineer") {
      var retrievedData = localStorage.getItem("user");
      var data = JSON.parse(retrievedData);
      this.userId = data.id;
    }
    this.role = localStorage.getItem("role");
    this.window_width = $(window).width() + 17; //default
    this.showorhide();

    this.getGroupList(this.$route.query.page);
  },
  watch: {
    $route(to, from) {
      this.getGroupList(this.$route.query.page);
    }
  },
  components: {
    appSidenav: e_sidenav
  },
  computed: {
    onResize(event) {
      this.window_width = $(window).width() + 17;
      this.showorhide();
      this.getGroupList(this.$route.query.page);
    }
  },

  methods: {
    showorhide() {
      if (this.window_width > 768) {
        $(".options").removeClass("hider");
        $(".options").addClass("show");
      }
      if (this.window_width <= 768) {
        $(".options").removeClass("show");
        $(".options").addClass("hider");
      }
    },
    clicked_moreoption() {
      if ($(".options").hasClass("hider")) {
        $(".options").removeClass("hider");
        $(".options").addClass("show");
      } else {
        $(".options").removeClass("show");
        $(".options").addClass("hider");
      }
    },
    prevPage() {
      if (this.page == 1) return;
      --this.page;
      this.getCompanyList();
    },
    nextPage(value) {
      if (this.totalPage < this.page) return;
      this.getCompanyList(value);
    },

    getGroupList(page) {
      var token = localStorage.getItem("token");
      if (page > 1) {
        page = page;
      }
      if (page < 1) {
        page = this.$route.query.page;
      }
      this.loading = true;
      axios
        .get("/messages/answered?token=" + token, {
          headers: { "X-localization": localStorage.getItem("lan") }
        })
        .then(res => {
          if (!res.data.result) {
            if (res.data[0]) {
              this.$toaster.error(res.data[0]);
            }
            this.loading = false;
          } else {
            for (var i = 0; i < res.data.groups.length; i++) {
              if (res.data.groups[i].last_message != null)
                res.data.groups[i].last_message = res.data.groups[
                  i
                ].last_message
                  .replace(/\<br \/\>/g, " ")
                  .replace(/(?:\r\n|\r|\n|↵)/g, "");
              this.groups.push(res.data.groups[i]);
            }
            this.$forceUpdate();
            this.loading = false;
          }
        })
        .catch(error => console.log(error));
    },
    goToProfile(id) {},
    sandMsg(companyId) {
      var hashids = new Hashids("this is my salt", 8, "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890");
      this.$router.push("/global/chatroom/"+ hashids.encode(companyId));
    }
  }
};
</script>

<style scoped>
.companyad {
  width: 100%;
}

.leftad {
  padding: 70px 20px;
}

.rightad {
  text-align: center;
  padding: 30px 0px;
}

.slide_options {
  background-color: #f8fafa;
  border-radius: 30px;
  margin: 10px 0px;
  margin-top: 44px;
  padding: 5px 0px;
}

.slide_item {
  text-align: center;
  padding: 18px;
  cursor: pointer;
}

.spressed {
  text-align: center;
  padding: 18px;
  border-radius: 30px;
  background-color: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(40, 60, 80, 0.12);
}

.slide_txt {
  font-size: 1rem;
  font-weight: bold;
  color: #b4bec8;
}

.spressed .slide_txt {
  font-size: 1rem;
  font-weight: bold;
  color: #3d7dd8;
}

.pview {
  margin-top: 38.5px;
  margin-bottom: 80px;
}

.avatar {
  width: 80%;
}

.pgraytxt {
  opacity: 0.64;
  font-size: 1rem;
  font-weight: 500;
}

.cs_summary {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
  margin-top: 21px;
}

.pvlabel {
  margin-left: 20px;
}

.pv_btnpanel {
  padding: 0px 10%;
}

.updatebtn {
  width: 100%;
  height: 56px;
}

.pv_showchart {
  background-color: #f8f8fa;
  margin-top: 16px;
}

.eview {
  padding: 30px 15px;
}

.chartboxes {
  display: block;
  margin: auto;
  margin-bottom: 30px;
  max-width: 200px;
  height: 100px;
}

.statustitle {
  font-size: 1.25rem;
  font-weight: bold;
  margin-top: 34px;
  margin-bottom: 0.1rem;
}

.statusnum {
  position: absolute;
  /*right: 46%;
      top: 55%;*/
  font-weight: bold;
  font-size: 1.5rem;
}

.caltxt {
  margin-top: 45px;
}

.calpanel {
  text-align: right;
}

.searchbox {
  height: 40px;
  border-radius: 4px;
  background-color: #f0f2f4;
  border: 1px solid #58606800;
}

.input-group-append {
  border-top-right-radius: 6.4px;
  border-bottom-right-radius: 6.4px;
  background-color: #3d7dd8;
}

.input-group-append button {
  color: white;
  border: 1px solid #58606800;
}

.input-group-append:hover button {
  color: #3d7dd8 !important;
}

.btn-outline-secondary:hover {
  background-color: white;
  color: #3d7dd8 !important;
}

.extxt {
  font-size: 0.75rem;
  font-weight: 500;
  color: rgba(60, 80, 100, 0.8);
}

.checklabel {
  font-size: 0.8125rem;
  font-weight: 500;
}

.styled-checkbox + label:before {
  margin-right: 12px;
  margin-top: -2px;
}

.checkgrouplabel {
  font-size: 1rem;
  font-weight: 500;
}

.checkgrouppanel {
  margin-top: 45px;
}

.unstyled {
  margin-top: 13px;
}

.unstyled li {
  margin-top: 1px;
}

li:after {
  content: "\f107";
  font-family: FontAwesome;
  font-size: 22px;
  position: absolute;
  right: 30px;
  color: #6474847d;
  margin-top: -2px;
}

.companyview-topoptions {
  padding: 10px 15px;
  margin-top: 10px;
}

.companyview-topoptions .col-md-3 {
  padding: 0;
}

.companyview-topoptions .col-md-9 {
  padding: 0;
}

.selectdiv:after {
  content: "\f107";
  color: #6474847d;
  top: 3px;
}

.selectdiv select {
  height: 44px;
}

.rtoptions {
  margin-top: 14px;
  float: left;
  margin-left: 40px;
}

.ceboxes {
  margin: 16px;
  margin-top: 26px;
  margin-bottom: 0px;
  text-align: center;
}

#pointer {
  width: 59.7px;
  height: 24px;
  background: #3d7dd8;
  box-shadow: 0 1px 2px 0 rgba(60, 80, 100, 0.12);

  position: absolute;
  z-index: 1;
  left: 0;
  top: 7px;
}

#pointer:after {
  content: "";
  position: absolute;
  right: -12px;
  bottom: 0;
  width: 0;
  height: 0;
  border-right: 12px solid transparent;
  border-top: 12px solid #3d7dd8;
  border-bottom: 12px solid transparent;
}

#pointer:before {
  content: "";
  position: absolute;
  right: -12px;
  bottom: 0;
  width: 0;
  height: 0;
  border-left: 12px solid #3d7dd8;
  border-top: 12px solid transparent;
}

.newtag {
  font-size: 0.6875rem;
  font-weight: bold;
  color: white;
}

.c_images {
  width: 85%;
  border-radius: 18px;
}

.ctitle {
  font-size: 1.125rem;
  font-weight: 500;
  margin-bottom: 20px;
  margin-top: 10px;
}

.ccontents {
  font-size: 0.625rem;
}

.cline {
  border: solid 0.5px #e6e8ea;
  margin-top: 15px;
  margin-bottom: 15px;
}

.cstitle {
  font-size: 0.8125rem;
  font-weight: 500;
  margin-bottom: 15px;
}

.clickcbtn {
  border-radius: 20px;
  padding: 7px 14px;
  box-shadow: 0 1px 4px 0 rgba(40, 60, 80, 0.4);

  float: right;
  margin-top: 10px;
  margin-bottom: 20px;
}

.cplus {
  font-size: 1.5em;
  line-height: 1;
}

.skillsets {
  text-align: left;
  padding: 9px 10px;
}

@media screen and (max-width: 992px) {
  .rightad {
    padding: 50px 0px;
  }
}

@media screen and (max-width: 768px) {
  .avatar {
    width: 50%;
  }

  .page_title {
    margin-top: 40px;
  }

  .pvlabel {
    margin-left: 0px;
  }

  .calpanel {
    text-align: center;
  }

  .rightad {
    padding: 0px 10px;
  }

  .leftad {
    padding: 20px 10px;
  }

  .rtoptions {
    margin-top: 14px;
    float: none;
    margin-left: 0px;
  }

  .skillsets {
    padding: 0;
    margin-top: 20px;
  }

  .ceboxes .col-md-3 {
    margin-bottom: 30px;
  }

  .c_images {
    width: 144px;
  }
}
</style>
